import type { LucideIcon } from 'lucide-react';
import { FileUpIcon, PencilIcon } from 'lucide-react';
import { type CompetitorTab } from '../../../model/analysisFormStore';
import { i18n } from '@/shared/i18n';

export { DOCUMENT_EXTRACTION_TAB, CREATE_MANUALLY_TAB } from '../shared/constants';

// Getters, not values: this array is built while the module is evaluated, so resolving per
// read is what lets the copy follow a language change instead of freezing at import.
export const TABS: { value: CompetitorTab; label: string; icon: LucideIcon }[] = [
  {
    value: 'document',
    icon: FileUpIcon,
    get label() {
      return i18n.t('analysis:analysis.competitorsStep.uploadDocument');
    },
  },
  {
    value: 'manual',
    icon: PencilIcon,
    get label() {
      return i18n.t('analysis:analysis.competitorsStep.createManually');
    },
  },
];
